import { Card, CardContent } from "@mui/material";

export default function SectionCard({ children, sx, ...props }) {
  return (
    <Card {...props} sx={{ marginBottom: 4, ...props }}>
      <CardContent>{children}</CardContent>
    </Card>
  );
}
